if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();

      this.mode = (this.dataset.mode || 'fixed').toLowerCase();
      this.second = 1000;
      this.minute = 60 * this.second;
      this.hour = 60 * this.minute;
      this.day = 24 * this.hour;

      if (this.mode === 'weekly') {
        this.weeklyEndDay = Number(this.dataset.weeklyEndDay);
        if (Number.isNaN(this.weeklyEndDay)) this.weeklyEndDay = 0;
        this.weeklyEndTime = this.dataset.weeklyEndTime || '23:59';
        this.endDate = this.nextWeeklyEnd().getTime();
      } else {
        this.endDate = new Date(this.dataset.endDate).getTime();
        if (!Number(this.endDate)) return;
      }

      window.initLazyScript(this, this.init.bind(this));
    }

    /**
     * Next real weekly cycle end (same for all visitors at a given moment).
     * When the deadline passes, the next call returns the following week's end.
     */
    nextWeeklyEnd(from = new Date()) {
      const [hhRaw, mmRaw] = String(this.weeklyEndTime).split(':');
      let hours = parseInt(hhRaw, 10);
      let mins = parseInt(mmRaw, 10);
      if (Number.isNaN(hours)) hours = 23;
      if (Number.isNaN(mins)) mins = 59;

      const target = new Date(from.getTime());
      target.setSeconds(0, 0);
      target.setHours(hours, mins, 0, 0);

      const currentDow = from.getDay(); // 0=Sun … 6=Sat
      let addDays = this.weeklyEndDay - currentDow;
      if (addDays < 0) addDays += 7;
      // If today is the end day but time already passed → next week
      if (addDays === 0 && from.getTime() >= target.getTime()) {
        addDays = 7;
      }
      target.setDate(target.getDate() + addDays);
      return target;
    }

    init() {
      this.daysEl = this.querySelector('.js-days');
      this.hoursEl = this.querySelector('.js-hours');
      this.minsEl = this.querySelector('.js-mins');
      this.secsEl = this.querySelector('.js-secs');
      if (!this.daysEl || !this.hoursEl || !this.minsEl || !this.secsEl) return;

      this.timer();
      this.interval = setInterval(this.timer.bind(this), this.second);
    }

    timer() {
      let timeDiff = this.endDate - Date.now();

      // Weekly: roll into the next real cycle when this one ends
      if (timeDiff < 0 && this.mode === 'weekly') {
        this.endDate = this.nextWeeklyEnd().getTime();
        timeDiff = this.endDate - Date.now();
      }

      if (timeDiff < 0) {
        clearInterval(this.interval);
        return;
      }

      const days = Math.floor(timeDiff / this.day);
      const hours = Math.floor(timeDiff / this.hour);
      const mins = Math.floor(timeDiff / this.minute);
      const secs = Math.floor(timeDiff / this.second);

      this.daysEl.textContent = days;
      this.hoursEl.textContent = hours - days * 24;
      this.minsEl.textContent = mins - hours * 60;
      this.secsEl.textContent = secs - mins * 60;
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}
